const faqs = [
  {
    q: '爆瓜网的内容来源可靠吗？',
    a: '我们的编辑团队7×24小时追踪全网娱乐资讯，所有内容均经过双重审核机制把关，确保信息的真实性和时效性。对于未经证实的传闻，我们会明确标注「待证实」标签。',
  },
  {
    q: '如何第一时间获取最新爆料？',
    a: '收藏爆瓜网官网入口并添加到手机桌面，每日刷新即可看到最新内容。我们会在重大爆料发生后的5分钟内完成上线，确保你比朋友圈更快一步。',
  },
  {
    q: '可以向爆瓜网投稿吗？',
    a: '当然可以！我们非常欢迎瓜友投稿。你可以通过投稿邮箱 tips@baogua.com 或官方微信发送线索，优质爆料一经采用即付稿酬，并严格保护投稿人隐私。',
  },
  {
    q: '爆瓜网需要注册登录吗？',
    a: '不需要。爆瓜网所有内容完全免费开放，无需注册登录即可浏览全部资讯。我们希望让每一个瓜友都能毫无门槛地享受吃瓜的快乐。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="text-base font-heading text-foreground-950 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}